<template>
  <article class="view">
    <header class="view__header" v-if="header">
      <VBlock class="view__crown" max-width="106px">
        <img src="@/assets/crown.png" />
      </VBlock>

      <div class="view__bar">
        <VText center big>{{ header }}</VText>

        <router-link class="view__back"
          v-if="backButtonTo"
          :to="backButtonTo"
        />
      </div>

      <hr />

    </header>

    <main class="view__content">
      <slot />
    </main>
  </article>
</template>

<script>
export default {
  name: 'VView',

  props: {
    backButtonTo: {
      type: String,
    },

    header: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.view {
  &__header {
    position: relative;

    padding: $gridGutter;

    hr {
      display: block;
      border: none;
      height: 5px;
      // width: 100%;
      background-color: #1a1109;
      margin: 3px calc($gridGutter * -1) 0;
    }
  }

  &__crown {
    margin-bottom: -30px !important;
  }

  &__bar {
    position: relative;
    margin: 0 calc($gridGutter * -1);
    padding: calc($gridGutter * 0.5) $gridGutter calc($gridGutter * 0.5 - 5px);

    background-color: #1a1109;

    ::v-deep .text {
      color: #ffffff;
    }
  }

  &__back {
    position: absolute;

    top: 50%;
    left: $gridGutter;
    width: 52px;
    height: 44px;
    transform: translateY(-50%);

    background-image: url('~@/assets/icon-back.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;

    &:hover {
      background-image: url('~@/assets/icon-back-hover.png');
    }

    @media screen and (max-width: 900px) {
      width: 44px;
      height: 36px;
    }
  }

  &__content {
    padding: calc($gridGutter * 2) calc($gridGutter * 3);

    @media screen and (max-width: 900px) {
      padding: calc($gridGutter * 2);
    }
  }
}
</style>
